import { Button, CircularProgress, LinearProgress, Stack, Typography } from "@mui/material";
import { calculateProgress } from "helpers/incomeEntry";
import { MdWarningAmber } from "react-icons/md";
import { IIncomeEntryArticle } from "types";

interface IncomeEntryArticleProgressProps {
  articles: IIncomeEntryArticle[];
  loading: boolean;
  onConfirm: () => void;
}

type CtaColor = "success" | "warning" | "inherit";

export default function IncomeEntryArticleProgress({
  articles,
  loading,
  onConfirm,
}: IncomeEntryArticleProgressProps) {
  const {
    totalArticles: totalProducts,
    completedArticles: completedProducts,
    totalBundles,
    resolvedBundles,
    pendingBundles,
    totalObservations,
    allResolved,
    percentage,
  } = calculateProgress(articles);

  let ctaLabel: string;
  let ctaColor: CtaColor;
  let ctaEnabled: boolean;

  if (!allResolved) {
    ctaLabel = `${pendingBundles} fardo${pendingBundles !== 1 ? "s" : ""} pendiente${
      pendingBundles !== 1 ? "s" : ""
    }`;
    ctaColor = "inherit";
    ctaEnabled = false;
  } else if (totalObservations > 0) {
    ctaLabel = `Confirmar con ${totalObservations} observación${
      totalObservations !== 1 ? "es" : ""
    }`;
    ctaColor = "warning";
    ctaEnabled = true;
  } else {
    ctaLabel = "Confirmar verificación";
    ctaColor = "success";
    ctaEnabled = true;
  }

  const barColor = allResolved && totalObservations > 0 ? "warning" : "success";

  return (
    <>
      <Stack direction="row" justifyContent="space-between" sx={{ mb: 1 }}>
        <Typography variant="body2" color="text.secondary">
          Progreso de verificación
        </Typography>
        <Typography variant="body2" fontWeight={700}>
          {completedProducts} de {totalProducts} productos · {resolvedBundles}/
          {totalBundles} fardos
        </Typography>
      </Stack>

      <LinearProgress
        variant="determinate"
        value={percentage}
        color={barColor}
        sx={{ height: 7, borderTopLeftRadius: 4, borderTopRightRadius: 4 }}
      />

      {totalObservations > 0 && (
        <Stack
          direction="row"
          alignItems="center"
          spacing={0.75}
          sx={{ mt: 1.25, px: 1 }}
        >
          <MdWarningAmber color="currentColor" style={{ color: "inherit" }} />
          <Typography variant="body2" color={ loading ? "text.disabled" : "warning.main"}>
            {totalObservations} fardo{totalObservations !== 1 ? "s" : ""} con
            observación — se informará en el ingreso
          </Typography>
        </Stack>
      )}

      <Button
        variant="contained"
        color={ctaColor === "inherit" ? undefined : ctaColor}
        fullWidth
        size="large"
        disabled={loading || !ctaEnabled}
        onClick={onConfirm}
        sx={{ py: 1.5, fontWeight: 700, borderTopLeftRadius: 0, borderTopRightRadius: 0 }}
      >
        {loading ? <CircularProgress color={ctaColor === "inherit" ? undefined : ctaColor} size={24}/> : ctaLabel}
      </Button>
    </>
  );
}
